import { Draft } from 'immer'
import { User } from '@opallabs/concepts'
import { BlockResponse } from '../types'

type UpdateBlockBoardsParams = {
  id: string
  title: string
  description: string | null
  imageSrc: string | null
  isPublic: boolean
  creator: Pick<User, 'uuid' | 'name' | 'legacyId' | 'asset'>
}

export const updateBlockBoards = (boards: Array<UpdateBlockBoardsParams>) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument
    draftDocument.data.boards = boards.map((board) => {
      const { id, title, description, imageSrc, isPublic, creator } = board
      return {
        id,
        title,
        description,
        image_source: imageSrc,
        is_public: isPublic,
        creator: {
          id: creator.uuid,
          full_name: creator.name,
          legacy_id: creator.legacyId,
          avatar_url: creator.asset?.url ?? null,
        },
      }
    })
    return draftDocument
  }
}
